// Angular
import { Injectable } from '@angular/core';

// rxjs
import { timer, Observable, Subject, Subscription } from 'rxjs';

// angulartics
import { Angulartics2 } from 'angulartics2';

interface IdleOptions {
  idle: number;
  timeout: number;
}

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private idleTimerSubscription: Subscription;
  private timeoutTimerSubscription: Subscription;
  private onTimeoutSubscription: Subscription;
  private onTimeoutStartedSubscription: Subscription;
  private idleTimer$: Observable<any>;
  private timeoutTimer$: Observable<any>;

  public onTimeout$: Subject<boolean>;
  public onTimeoutStarted$: Subject<boolean>;
  public resetCountdown$: Subject<number>;
  public options: IdleOptions;

  constructor(private angulartics2: Angulartics2) {
    this.idleTimer$ = timer(1000, 1000);
    this.timeoutTimer$ = timer(0, 1000);
    this.onTimeoutStarted$ = new Subject<boolean>();
    this.onTimeout$ = new Subject<boolean>();
    this.resetCountdown$ = new Subject<number>();
    this.options = { idle: 45, timeout: 12 };
  }

  public destroy() {
    if (this.idleTimerSubscription) {
      this.idleTimerSubscription.unsubscribe();
    }
    if (this.timeoutTimerSubscription) {
      this.timeoutTimerSubscription.unsubscribe();
    }
    if (this.onTimeoutSubscription) {
      this.onTimeoutSubscription.unsubscribe();
    }
    if (this.onTimeoutStartedSubscription) {
      this.onTimeoutStartedSubscription.unsubscribe();
    }
  }

  public resetTimer() {
    this.destroy();
    this.startWatching();
    this.onTimeout$.next(false);
  }

  public startWatching() {
    this.idleTimerSubscription = this.idleTimer$.subscribe((value) => {
      if (value === this.options.idle) {
        this.onTimeoutSubscription = this.onTimeout$.subscribe();
        this.onTimeoutStarted$.next(true);
        this.startTimeout();
      }
    });
  }

  public startTimeout() {
    this.onTimeoutStartedSubscription = this.onTimeoutStarted$.subscribe();
    this.timeoutTimerSubscription = this.timeoutTimer$.subscribe((value) => {
      const countdown: number = this.options.timeout - value;

      if (countdown < 0) {
        return;
      }

      this.resetCountdown$.next(countdown);

      if (value === this.options.timeout) {
        this.onTimeout$.next(true);
      }
    });
  }
}
